import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { parseString } from "xml2js";
import api from "../../../api";
import getPersonName from "../../common/Name";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import { getDobDate, getMonthAndYear } from "../../common/DisplayDate";
import PhysicalDescription from "../PhysicalDescription";
import AliasesDetail from "../AliasesDetail";
import AddressDetail from "../AddressDetail";
import Offenses from "../Offenses";

class CriminalRecordsPrimarySource extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    const { isSilverReport } = this.props;
    if (isSilverReport) this.loadSection(this.props.node, this.props);
    else this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      const { isSilverReport } = nextProps;
      if (isSilverReport) this.loadSection(this.props.node, nextProps);
      else this.loadData(nextProps);
    }
  }

  onReportIndexChanged = (currentIndex) => {
    this.setState({
      activeIndex: currentIndex,
    });
  };

  loadSection = (records, props) => {
    const rows = [];
    let recCount = 0;
    if (records !== undefined) {
      const { isSilverReport } = props;
      if (isSilverReport) {
        _.forEach(records, (record, index) => {
          const suspect = _.get(record, "suspect[0]");
          const name = getPersonName(
            _.get(suspect, "name[0].firstName[0]._", ""),
            "",
            _.get(suspect, "name[0].lastName[0]._", ""),
            props
          );
          const dob = getMonthAndYear(_.get(suspect, "DOB[0]"));
          const crimDetails = _.get(
            record,
            "crimeDetailsRecords[0].crimeDetails"
          );
          if (crimDetails && crimDetails.length > 0) {
            _.forEach(crimDetails, (crimDetail, crimIndex) => {
              rows.push(
                <Table.Row
                  key={`rep_crim_prim_row_1_${index}_${crimIndex}`}
                  className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell width={2}>Name:</Table.Cell>
                  <Table.Cell width={3}>{name}</Table.Cell>

                  <Table.Cell width={3}>Date Of Birth:</Table.Cell>
                  <Table.Cell width={2}>{dob}</Table.Cell>

                  <Table.Cell width={2}>Category:</Table.Cell>
                  <Table.Cell width={4}>
                    {_.get(crimDetail, "classification[0]._", "")}
                  </Table.Cell>
                </Table.Row>
              );
              rows.push(
                <Table.Row
                  key={`rep_crim_prim_row_2_${index}_${crimIndex}`}
                  className={recCount % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell width={2}>State:</Table.Cell>
                  <Table.Cell width={3}>
                    {_.get(crimDetail, "sourceState[0]._", "")}
                  </Table.Cell>

                  <Table.Cell width={3}>Source/Jurisdiction:</Table.Cell>
                  <Table.Cell colSpan={3}>
                    {_.get(crimDetail, "court[0]._", "")}{" "}
                  </Table.Cell>
                </Table.Row>
              );
              recCount += 1;
            });
          }
        });
      } else {
        _.forEach(records, (record, index) => {
          let fullNameWithJurisdiction = "";
          if (record !== undefined) {
            fullNameWithJurisdiction = `${record.fullName[0]._} ${record.sourceorjurisdiction[0]._}`;
          }
          const innerRows = [];
          const addNode = _.get(record, `addresses[0].address[0]`);
          innerRows.push(
            <Table.Row
              id={`inst_crim_row_${index}`}
              key={`inst_crim_row_${index}`}
            >
              <Table.Cell>
                <PhysicalDescription descNode={record} {...this.props} />
                {_.get(record, "aliases[0].alias[0]") !== undefined ? (
                  <AliasesDetail
                    aliasNode={record.aliases[0]}
                    dob={getDobDate(_.get(record, "fulldob[0]._", ""), {
                      userAccount: this.props.userAccount,
                      isDobValue: true,
                    })}
                  />
                ) : (
                  <span />
                )}
                {addNode !== undefined ? (
                  <AddressDetail addNode={addNode} {...this.props} />
                ) : (
                  <span />
                )}
                <Offenses
                  offensesNode={_.get(record, "offenses[0]")}
                  {...this.props}
                  caseNumber={_.get(record, "caseNumber[0]")}
                  countyorjurisdiction={_.get(record, "countyorjurisdiction[0]")}
                />
              </Table.Cell>
            </Table.Row>
          );
          rows.push(
            <SimpleAccordionContent
              {...this.props}
              name={fullNameWithJurisdiction}
              rows={innerRows}
              key={`inst_crim_acc_${index}`}
              accId={`inst_crim_acc_${index}`}
            />
          );
          recCount += 1;
        });
      }
    }
    if (recCount < 1) {
      rows.push(
        <Table.Row key={`no_recs_row_100`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  loadData = (props) => {
    const records = _.get(props, "reportData.personReport.instantcrims[0].inmateSearch[0].criminalinformation[0].records[0].record");
    if (!localStorage.crimLoad && !records) {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "instantcrim";
      localStorage.crimLoad = true;
      api.report
        .person(additionalData)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            const crimsRecords = _.get(
              rslt,
              "personReport.instantcrims[0].inmateSearch[0].criminalinformation[0].records[0].record"
            );
            this.loadSection(crimsRecords, props);
            localStorage.removeItem("crimLoad");
          });
        })
        .catch((err) => console.log("criminal res error - ", err));
    } else {
      this.loadSection(records, props);
    }
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Criminal Records Involving Subject - Primary Source"}
        rows={this.state.rows}
      />
    );
  }
}

export default CriminalRecordsPrimarySource;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/CriminalRecordsPrimarySource.js